import { Controller } from "@hotwired/stimulus"

// Copie un texte (valeur, champ ou contenu récupéré depuis une URL) dans le presse-papier.
export default class extends Controller {
  static targets = ["source", "label"]
  static values = { text: String, url: String, label: { type: String, default: "Copié !" } }

  async copy(event) {
    event.preventDefault()
    try {
      if (this.hasUrlValue && this.urlValue) {
        // ClipboardItem + promesse : garde le « geste utilisateur » valide sur Safari pendant le fetch
        const blob = fetch(this.urlValue, { headers: { Accept: "text/markdown" } })
          .then((r) => r.text()).then((t) => new Blob([t], { type: "text/plain" }))
        if (window.ClipboardItem) {
          await navigator.clipboard.write([new ClipboardItem({ "text/plain": blob })])
        } else {
          await navigator.clipboard.writeText(await (await blob).text())
        }
      } else {
        const text = this.hasTextValue && this.textValue ? this.textValue : this.sourceTarget.value
        await navigator.clipboard.writeText(text)
        if (this.hasSourceTarget) this.sourceTarget.select()
      }
      this.flash(this.labelValue)
    } catch (e) {
      this.flash("Copie impossible")
    }
  }

  flash(text) {
    if (!this.hasLabelTarget) return
    this.original ??= this.labelTarget.textContent
    this.labelTarget.textContent = text
    clearTimeout(this.timer)
    this.timer = setTimeout(() => (this.labelTarget.textContent = this.original), 1800)
  }
}
